import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";
import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { LANDSCAPE_COMPRESSED_CONTENT_MAX_HEIGHT } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._constants";
import { useCallback } from "react";

export function useDrillPageLandscapeLayout() {
  const [orientation] = useContextSelectors(RootContext, (c) => c.orientation);
  const [landscapeMainContentHeight, setLandscapeMainContentHeight] = useContextSelectors(
    DrillPageContext,
    (c) => c.landscapeMainContentHeight,
    (c) => c.setLandscapeMainContentHeight,
  );
  const isLandscapeCompressed =
    orientation === "landscape" &&
    landscapeMainContentHeight < LANDSCAPE_COMPRESSED_CONTENT_MAX_HEIGHT;

  const handleLandscapeMainContentLayout = useCallback(
    (e: { nativeEvent: { layout: { height: number } } }) => {
      const nextHeight = Math.round(e.nativeEvent.layout.height);
      setLandscapeMainContentHeight((prev) => (prev === nextHeight ? prev : nextHeight));
    },
    [setLandscapeMainContentHeight],
  );

  return { handleLandscapeMainContentLayout, isLandscapeCompressed };
}
